// Investiture
import React from 'react';
import { Englishcca2class2026 } from '../views';

const InvestiturePage = () => {
  return <Englishcca2class2026 />;
};

export default InvestiturePage;
